import { ITimeoutService } from "angular";
import { IWorkItemScope, WorkItemController } from "../workItemController";

export class ConfirmationWorkItemController extends WorkItemController {
  static $inject = ["$scope", "$timeout"];

  tempActive: boolean = false;

  constructor($scope: IWorkItemScope, $timeout: ITimeoutService) {
    super($scope);

    //checkbox we are using doesn't show proper value if disabled.
    //Here we temporarily activate it so it will render the correct value
    //and then we disable it
    if (!this.fieldActive && this.field.Value) {
      this.tempActive = true;
      $timeout(0).then(() => {
        this.tempActive = false;
      });
    }
  }
}
